/** Kopf über dem Planer am Rechner: Titel, Hinweis aufs Ziehen, drei Kennzahlen. Bis 16.10.2026 in PlanungPage. */
export function PlanerTitel({ personalkosten, offeneSlots, kommend, ohneSlot, helfer, inhaber }: {
  personalkosten: string; offeneSlots: number; kommend: number; ohneSlot: number; helfer: number; inhaber: number;
}) {
  return (
    <div className="pl-head">
      <div>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800 }}>Termine &amp; Helfer-Planung</h1>
        {/* Der Hinweis auf das Ziehen steht hier, weil die Funktion sonst
            unauffindbar ist: Alt-Ziehen kopiert seit jeher, sagte es aber
            niemandem. Auf dem Telefon wird der ganze Kopf ausgeblendet —
            dort gibt es kein Ziehen, sondern „Verschieben“ im Termin. */}
        <div style={{ color: "var(--vg-text-3)", marginTop: 4, fontSize: 13 }}>Auf einen Tag klicken, um einen Termin anzulegen · Chip anklicken zum Bearbeiten · Chip ziehen verschiebt, mit ⌥/Alt kopiert</div>
      </div>
      <div className="pl-kpis">
        <Kpi label="Offene Personalkosten" value={personalkosten} sub={`${offeneSlots} Slots offen`} accent="var(--vg-amber)" />
        <Kpi label="Kommende 14 Tage" value={String(kommend)} sub={`${ohneSlot} ohne Slot`} />
        <Kpi label="Team aktiv" value={String(helfer + inhaber)} sub={`${helfer} Helfer · ${inhaber} Inhaber`} />
      </div>
    </div>
  );
}

/** Kennzahl-Kachel im Planer-Kopf (Rechner). Bis 13.10.2026 in PlanungPage. */
export function Kpi({ label, value, sub, accent }: { label: string; value: string; sub?: string; accent?: string }) {
  return (
    <div className="pl-kpi">
      <div className="pl-kpi-label">{label}</div>
      <div className="pl-kpi-value" style={accent ? { color: accent } : undefined}>{value}</div>
      {sub && <div className="pl-kpi-sub">{sub}</div>}
    </div>
  );
}
